import parsePhoneNumberFromString, { getCountryCallingCode } from "libphonenumber-js";

/**
 * Returns a phone number in E.164 format (+<callingCode><number>).
 *
 * Resolution order:
 *  1. rawPhoneNumber is already valid E.164 → return as-is.
 *  2. rawPhoneNumber digits prefixed with "+" are valid E.164 → return that
 *     (handles numbers that are correct but missing the leading +).
 *  3. Build from countryCode, which may be an ISO alpha-2 ("US"), a numeric
 *     calling code ("1"), or a prefixed calling code ("+1").
 *  4. Return fallback.
 */
export function formatToE164(rawPhoneNumber, countryCode, fallback = '') {
    if (!rawPhoneNumber) return fallback;

    const parsed = parsePhoneNumberFromString(rawPhoneNumber);
    if (parsed && parsed.isValid()) {
        return parsed.number;
    }

    const digits = rawPhoneNumber.replace(/\D/g, '');
    if (!digits) return fallback;

    // Handle numbers that are fully formed but just missing the leading +
    const parsedWithPlus = parsePhoneNumberFromString(`+${digits}`);
    if (parsedWithPlus && parsedWithPlus.isValid()) {
        return parsedWithPlus.number;
    }

    if (countryCode) {
        try {
            // countryCode can be "US" (alpha-2), "1", or "+1" (numeric calling code)
            const callingCode = /^\+?\d+$/.test(String(countryCode))
                ? String(countryCode).replace(/\D/g, '')
                : getCountryCallingCode(countryCode);
            return `+${callingCode}${digits}`;
        } catch (_) {
            // unrecognised countryCode — fall through to fallback
        }
    }

    return fallback;
}
